//import logo from '../../image/Logo.png';
//import burger from '../../image/burger_black.png'
import s from "./company.module.css";
import prod from "../../image/Product.jpg";
import PageHelmet from "../PageHelmet";
//import { useNavigate } from 'react-router-dom';

const Company = () => {
  return (
    <div>
      <PageHelmet />
      <div className={s.company}>
        <div className={s.container}>
          <div className={s.blockTitle}>
            <p className={s.textTitle}>
              ООО "ПремексБел" 28 лет является одним из{" "}
              <span className={s.text4}>ведущих производителей </span>
              счетчиков воды и тепла, предлагая{" "}
              <span className={s.text4}>
                {" "}
                высококачественные и надежные решения
              </span>{" "}
              для учета коммунальных ресурсов.
            </p>
            <div className={s.picTitle}>
              <img className={s.producTitle} src={prod} alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Company;
